import produce from "immer";

import {
  SESSION_ADD,
  SESSION_WATCH_ON,
  SESSION_WATCH_OFF
} from "../actions/types";

const initialState = {};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case SESSION_ADD:
        console.log("no need to update store");
        break;
      case SESSION_WATCH_ON:
        draft = action.payload;
        return draft;
      case SESSION_WATCH_OFF:
        console.log(action.payload);
        // draft = action.payload;
        // return draft;
        break;
    }
  });
};
